import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const WithBottomBorder = styled.div<{ active: boolean }>`
  height: 2px;
  position: absolute;
  left: 40px;
  pointer-events: none;
  font-size: 0;
  width: 100%;
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  bottom: 0;
  background: ${({ active }) =>
    active ? theme.color.designSystem.purple70 : 'transparent'};
`;
